export default {
    API_URL: 'https://webstaticapi.omnicasa.com/api',
};
